// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash-container {
    padding: 20px;
    background: #f8fafc;
    /* border: 5px solid red; */
}

/* VIEW TRANSITIONS */
.dash-body {
    position: relative;
}

.dash-body-inner {
    transition: opacity 0.28s ease, filter 0.28s ease, transform 0.28s ease;
}

.dash-body.is-refreshing .dash-body-inner {
    opacity: 0.42;
    filter: saturate(0.6) blur(1.5px);
    transform: scale(0.995);
    pointer-events: none;
}

.dash-body-inner > * {
    animation: dash-rise 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.dash-body-inner > *:nth-child(1) { animation-delay: 0ms; }
.dash-body-inner > *:nth-child(2) { animation-delay: 70ms; }
.dash-body-inner > *:nth-child(3) { animation-delay: 140ms; }
.dash-body-inner > *:nth-child(4) { animation-delay: 210ms; }

.dash-kpi-row > .dash-kpi {
    animation: dash-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.dash-kpi-row > .dash-kpi:nth-child(1) { animation-delay: 80ms; }
.dash-kpi-row > .dash-kpi:nth-child(2) { animation-delay: 130ms; }
.dash-kpi-row > .dash-kpi:nth-child(3) { animation-delay: 180ms; }
.dash-kpi-row > .dash-kpi:nth-child(4) { animation-delay: 230ms; }
.dash-kpi-row > .dash-kpi:nth-child(5) { animation-delay: 280ms; }

.dash-table tbody tr {
    animation: dash-fade 0.45s ease both;
}

.dash-table tbody tr:nth-child(1) { animation-delay: 200ms; }
.dash-table tbody tr:nth-child(2) { animation-delay: 240ms; }
.dash-table tbody tr:nth-child(3) { animation-delay: 280ms; }
.dash-table tbody tr:nth-child(4) { animation-delay: 320ms; }
.dash-table tbody tr:nth-child(n + 5) { animation-delay: 360ms; }

.status-bar-fill {
    transform-origin: left center;
    animation: dash-bar-grow 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;
}

.dash-progress {
    position: absolute;
    top: -6px;
    left: 0;
    right: 0;
    height: 3px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(30, 113, 187, 0.12);
    z-index: 2;
}

.dash-progress span {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 35%;
    border-radius: 999px;
    background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
    animation: dash-progress 1.1s ease-in-out infinite;
}

@keyframes dash-rise {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes dash-fade {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes dash-bar-grow {
    from { transform: scaleX(0); }
    to { transform: scaleX(1); }
}

@keyframes dash-progress {
    0% { left: -35%; }
    100% { left: 100%; }
}

@media (prefers-reduced-motion: reduce) {
    .dash-body-inner > *,
    .dash-kpi-row > .dash-kpi,
    .dash-table tbody tr,
    .status-bar-fill,
    .dash-progress span {
        animation: none;
    }
}

/* LIVE STRIP */
.dash-live {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
    padding: 12px 16px;
    border-radius: 12px;
    background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
    color: #fff;
    box-shadow: 0 2px 10px rgba(30, 113, 187, 0.25);
}

.dash-live-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 13px;
    font-weight: 600;
}

.dash-live-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.16);
    font-size: 11px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
}

.dash-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #22c55e;
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
    animation: dash-pulse 1.8s infinite;
}

.dash-live-sep {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
}

.dash-live-time {
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
    white-space: nowrap;
}

@keyframes dash-pulse {
    70% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
    100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

/* KPI ROW */
.dash-kpi-row {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 16px;
}

.dash-kpi {
    background: #fff;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    min-width: 0;
}

.dash-kpi-top {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.dash-kpi-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(30, 113, 187, 0.12);
    color: #1e71bb;
    flex-shrink: 0;
}

.dash-kpi-icon-up {
    background: rgba(22, 163, 74, 0.12);
    color: #16a34a;
}

.dash-kpi-icon-down {
    background: rgba(239, 68, 68, 0.12);
    color: #ef4444;
}

.dash-kpi-icon svg {
    font-size: 16px;
}

.dash-kpi-label {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.3;
}

.dash-kpi-value {
    font-size: 22px;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
    word-break: break-word;
}

.dash-kpi-delta {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    margin-top: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
}

.dash-kpi-delta-up { color: #16a34a; }
.dash-kpi-delta-down { color: #ef4444; }
.dash-kpi-delta-watch { color: #d97706; }
.dash-kpi-delta-neutral { color: #6b7280; }

/* PANELS */
.dash-panel {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.dash-panel-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.dash-muted {
    margin: 2px 0 0;
    font-size: 12px;
    color: #6b7280;
}

.dash-text-btn {
    border: 0;
    background: transparent;
    color: #1e71bb;
    font-size: 13px;
    font-weight: 600;
    padding: 0;
    white-space: nowrap;
}

.dash-text-btn:hover {
    text-decoration: underline;
}

.dash-table-wrap {
    overflow-x: auto;
}

.inv-board {
    padding-bottom: 8px;
}

.inv-board-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}

.inv-board-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.dash-export-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 34px;
    padding: 0 14px;
    border: 1px solid transparent;
    border-radius: 10px;
    background: #eef3fb;
    color: #2b3991;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
}

.dash-export-btn i {
    font-size: 14px;
    line-height: 1;
}

.dash-export-btn:hover:not(:disabled) {
    background: #e2ebf8;
}

.dash-export-btn:disabled {
    opacity: 0.65;
    cursor: default;
}

.inv-mix {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
}

.inv-mix-bar {
    display: flex;
    height: 8px;
    border-radius: 999px;
    overflow: hidden;
    background: #eef2f6;
}

.inv-mix-bar span {
    display: block;
    height: 100%;
    min-width: 4px;
}

.inv-mix-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.inv-mix-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 30px;
    padding: 4px 10px;
    border: 1px solid #e6ebf2;
    border-radius: 999px;
    background: #f8fafc;
    color: #334155;
    font-size: 12px;
    line-height: 1;
}

.inv-mix-pill i {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

.inv-mix-pill strong {
    font-size: 12px;
    color: #0f172a;
}

.inv-mix-pill em {
    font-style: normal;
    color: #64748b;
}

.inv-mix-pill.is-total {
    background: #eef5fb;
    border-color: #c9dff3;
}

.inv-mix-empty {
    font-size: 12px;
    color: #6b7280;
}

.dash-inventory-wrap {
    max-height: 560px;
    overflow: auto;
    border: 1px solid #e8edf3;
    border-radius: 10px;
}

.inv-board .dash-inventory-table td {
    padding: 9px 10px;
}

.inv-board .inv-sku {
    font-weight: 600;
    color: #1e3a5f;
}

.inv-board tr.is-hold td {
    background: #fffaf3;
}

.inv-board td.is-hold-qty {
    color: #b45309;
    font-weight: 700;
}

.dash-table.dash-inventory-table {
    border-collapse: separate;
    border-spacing: 0;
}

.dash-inventory-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fff;
    box-shadow: inset 0 -1px 0 #e5e7eb;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: 0.3px;
}

.dash-inventory-table thead tr.dash-inventory-filter-row th {
    top: 34px;
    z-index: 1;
    padding: 6px 8px 8px;
    font-weight: 400;
    text-transform: none;
    letter-spacing: normal;
    box-shadow: inset 0 -1px 0 #e5e7eb;
    background: #f8fafc;
}

.dash-col-filter {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    border: 1px solid #d6dee8;
    border-radius: 6px;
    padding: 5px 8px;
    font-size: 12px;
    color: #111827;
    background: #fff;
    outline: none;
}

.dash-col-filter:focus {
    border-color: #1e71bb;
    box-shadow: 0 0 0 2px rgba(30, 113, 187, 0.12);
}

.dash-col-filter::placeholder {
    color: #94a3b8;
}

.dash-inventory-table th.dash-num,
.dash-inventory-table td.dash-num {
    text-align: right;
    white-space: nowrap;
}

.dash-table {
    width: 100%;
    border-collapse: collapse;
}

.dash-table th {
    text-align: left;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #6b7280;
    padding: 8px 10px;
    border-bottom: 1px solid #e5e7eb;
}

.dash-table td {
    padding: 12px 10px;
    font-size: 13px;
    color: #111827;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
}

.dash-table tbody tr:hover td {
    background: #f8fafc;
}

.dash-status-name {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
}

.dash-num {
    font-weight: 600;
}

.dash-muted-cell {
    color: #6b7280;
}

.dash-share {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 160px;
}

.dash-share .status-bar-bg {
    flex: 1 1;
}

.dash-share span {
    width: 40px;
    font-weight: 600;
    font-size: 13px;
}

.dash-table-empty,
.dash-chart-empty {
    text-align: center;
    color: #6b7280;
    font-size: 13px;
    padding: 28px 12px;
}

.dash-pill {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 600;
}

.dash-pill-open {
    background: #dbeafe;
    color: #1d4ed8;
}

.dash-pill-good {
    background: #dcfce7;
    color: #15803d;
}

.dash-pill-watch {
    background: #fef3c7;
    color: #b45309;
}

.dash-pill-critical {
    background: #fee2e2;
    color: #b91c1c;
}

.dash-split {
    display: grid;
    grid-template-columns: minmax(260px, 0.85fr) minmax(340px, 1.35fr);
    gap: 16px;
    margin-top: 16px;
}

.dash-rank-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 14px;
}

.dash-rank {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 4px;
    border-bottom: 1px solid #f3f4f6;
}

.dash-rank:last-child {
    border-bottom: 0;
}

.dash-rank-index {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
}

.dash-rank-body {
    flex: 1 1;
    min-width: 0;
}

.dash-rank-name {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}

.dash-rank-pct {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-size: 18px;
    font-weight: 700;
}

.dash-legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px 14px;
}

.dash-legend span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #374151;
}

.dash-legend i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}

.dash-tooltip {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    min-width: 160px;
}

.dash-tooltip-label {
    font-size: 12px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 6px;
}

.dash-tooltip-row {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #4b5563;
    margin-top: 4px;
}

.dash-tooltip-row strong {
    margin-left: auto;
    color: #111827;
}

@media (max-width: 1200px) {
    .dash-kpi-row {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 860px) {
    .dash-kpi-row,
    .dash-split {
        grid-template-columns: 1fr;
    }

    .dash-live {
        flex-direction: column;
        align-items: flex-start;
    }
}

/* CARD */
.card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.card-title {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
}

.subtitle {
    font-size: 12px;
    color: #6b7280;
}

/* STATUS */
.status-bars {
    margin-top: 10px;
}

.status-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.status-label {
    width: 120px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.status-bar-bg {
    flex: 1 1;
    height: 8px;
    background: #e5e7eb;
    border-radius: 4px;
}

.status-bar-fill {
    height: 100%;
    border-radius: 4px;
}

.status-count {
    width: 90px;
    font-weight: 600;
    text-align: right;
    font-size: 13px;
}

.status-percent {
    font-size: 11px;
    color: #6b7280;
}

/* BAR HEADER */
.card-header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chart-select {
    padding: 4px 8px;
    font-size: 12px;
}



/* ================= HEADER ================= */

.dashboard-header {
    background: #fff;
    padding: 10px 12px;
    border-radius: 14px;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(30, 57, 145, 0.06);
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dash-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.dash-toolbar-copy {
    min-width: 0;
}

.dashboard-header h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.01em;
    color: #111827;
}

.dashboard-header p {
    margin: 2px 0 0;
    font-size: 11px;
    line-height: 1.3;
    color: #6b7280;
}

.dash-view-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 0;
    padding: 4px;
    background: #f4f7fb;
    border: 1px solid #e6edf5;
    border-radius: 14px;
}

.dash-view-tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    background: transparent;
    color: #64748b;
    font-family: "Montserrat", sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    padding: 6px 12px 6px 6px;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.dash-view-tab:hover {
    background: rgba(255, 255, 255, 0.72);
    color: #1e293b;
}

.dash-view-tab.is-active {
    background: #fff;
    color: #111827;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 6px 16px rgba(30, 57, 145, 0.1);
}

.dash-view-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.dash-view-tab.is-active .dash-view-icon {
    transform: scale(1.04);
}

.dash-view-icon-po { background: #e4eef7; color: #1e71bb; }
.dash-view-icon-asn { background: #e6f6f8; color: #0e7490; }
.dash-view-icon-so { background: #eeeefe; color: #4f46e5; }
.dash-view-icon-shipment { background: #f3eefb; color: #6d28d9; }
.dash-view-icon-grn { background: #e8f6ee; color: #15803d; }
.dash-view-icon-inventory { background: #e7f4f2; color: #0f766e; }

.dash-view-tab.is-active .dash-view-icon-po { background: #1e71bb; color: #fff; }
.dash-view-tab.is-active .dash-view-icon-asn { background: #0e7490; color: #fff; }
.dash-view-tab.is-active .dash-view-icon-so { background: #4f46e5; color: #fff; }
.dash-view-tab.is-active .dash-view-icon-shipment { background: #6d28d9; color: #fff; }
.dash-view-tab.is-active .dash-view-icon-grn { background: #15803d; color: #fff; }
.dash-view-tab.is-active .dash-view-icon-inventory { background: #0f766e; color: #fff; }

/* ---- FILTER CARD ---- */
.dash-filter-card {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    flex-shrink: 1;
    background: #f4f7fb;
    border: 1px solid #e6edf5;
    border-radius: 12px;
    padding: 4px;
    box-shadow: none;
}

.dash-filter-inline {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    margin: 0;
    padding: 0 8px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    color: #64748b;
}

.dash-filter-inline span {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #64748b;
}

.dash-date-input {
    width: 124px;
    height: 28px;
    border: 0 !important;
    border-radius: 0 !important;
    padding: 0 !important;
    font-size: 12px !important;
    background: transparent !important;
    box-shadow: none !important;
}

.dash-date-input:focus {
    border: 0 !important;
    box-shadow: none !important;
}

.dash-warehouse-select {
    border: 0;
    background: transparent;
    font-size: 12px;
    color: #111827;
    max-width: 168px;
    outline: none;
    cursor: pointer;
}

.dash-filter-btn {
    padding: 0 12px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    height: 32px;
    line-height: 1;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: all 0.2s;
}

.dash-filter-reset {
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 8px;
    background: #fff;
    color: #64748b;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.dash-filter-reset:hover {
    background: #eef2f7;
    color: #111827;
}

.dash-filter-btn.btn-primary {
    box-shadow: 0 1px 4px rgba(37, 99, 235, 0.25);
}

.dash-filter-btn.btn-primary:hover {
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
}

.dash-filter-btn.btn-outline-secondary:hover {
    background: #f3f4f6;
}

.bar-card {
    margin-top: 20px;
}

/* ================= LOADER ================= */
.dashboard-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh;
    gap: 14px;
}

.loader-spinner {
    width: 36px;
    height: 36px;
    border: 4px solid #e5e7eb;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.dashboard-loader span {
    font-size: 14px;
    color: #6b7280;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/pages/tenant/dashboard/TenantDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,8DAA8D;AAClE;;AAEA,oCAAoC,oBAAoB,EAAE;AAC1D,oCAAoC,qBAAqB,EAAE;AAC3D,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;;AAE5D;IACI,6DAA6D;AACjE;;AAEA,yCAAyC,qBAAqB,EAAE;AAChE,yCAAyC,sBAAsB,EAAE;AACjE,yCAAyC,sBAAsB,EAAE;AACjE,yCAAyC,sBAAsB,EAAE;AACjE,yCAAyC,sBAAsB,EAAE;;AAEjE;IACI,oCAAoC;AACxC;;AAEA,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;AAC5D,wCAAwC,sBAAsB,EAAE;;AAEhE;IACI,6BAA6B;IAC7B,uEAAuE;AAC3E;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,+EAA+E;IAC/E,kDAAkD;AACtD;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,OAAO,oBAAoB,EAAE;IAC7B,KAAK,oBAAoB,EAAE;AAC/B;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI;;;;;QAKI,eAAe;IACnB;AACJ;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,+EAA+E;IAC/E,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC;IACrC,eAAe;IACf,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,MAAM,0CAA0C,EAAE;IAClD,OAAO,wCAAwC,EAAE;AACrD;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,qBAAqB,cAAc,EAAE;AACrC,uBAAuB,cAAc,EAAE;AACvC,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;;AAE1C,WAAW;AACX;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kEAAkE;IAClE,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA,SAAS;AACT;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;;;AAIA,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gFAAgF;IAChF,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,0EAA0E;AAC9E;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,+EAA+E;AACnF;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,sEAAsE;AAC1E;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE,8CAA8C,mBAAmB,EAAE,WAAW,EAAE;AAChF,+CAA+C,mBAAmB,EAAE,WAAW,EAAE;AACjF,8CAA8C,mBAAmB,EAAE,WAAW,EAAE;AAChF,oDAAoD,mBAAmB,EAAE,WAAW,EAAE;AACtF,+CAA+C,mBAAmB,EAAE,WAAW,EAAE;AACjF,qDAAqD,mBAAmB,EAAE,WAAW,EAAE;;AAEvF,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;IACrB,0BAA0B;IAC1B,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC","sourcesContent":[".dash-container {\n    padding: 20px;\n    background: #f8fafc;\n    /* border: 5px solid red; */\n}\n\n/* VIEW TRANSITIONS */\n.dash-body {\n    position: relative;\n}\n\n.dash-body-inner {\n    transition: opacity 0.28s ease, filter 0.28s ease, transform 0.28s ease;\n}\n\n.dash-body.is-refreshing .dash-body-inner {\n    opacity: 0.42;\n    filter: saturate(0.6) blur(1.5px);\n    transform: scale(0.995);\n    pointer-events: none;\n}\n\n.dash-body-inner > * {\n    animation: dash-rise 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.dash-body-inner > *:nth-child(1) { animation-delay: 0ms; }\n.dash-body-inner > *:nth-child(2) { animation-delay: 70ms; }\n.dash-body-inner > *:nth-child(3) { animation-delay: 140ms; }\n.dash-body-inner > *:nth-child(4) { animation-delay: 210ms; }\n\n.dash-kpi-row > .dash-kpi {\n    animation: dash-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.dash-kpi-row > .dash-kpi:nth-child(1) { animation-delay: 80ms; }\n.dash-kpi-row > .dash-kpi:nth-child(2) { animation-delay: 130ms; }\n.dash-kpi-row > .dash-kpi:nth-child(3) { animation-delay: 180ms; }\n.dash-kpi-row > .dash-kpi:nth-child(4) { animation-delay: 230ms; }\n.dash-kpi-row > .dash-kpi:nth-child(5) { animation-delay: 280ms; }\n\n.dash-table tbody tr {\n    animation: dash-fade 0.45s ease both;\n}\n\n.dash-table tbody tr:nth-child(1) { animation-delay: 200ms; }\n.dash-table tbody tr:nth-child(2) { animation-delay: 240ms; }\n.dash-table tbody tr:nth-child(3) { animation-delay: 280ms; }\n.dash-table tbody tr:nth-child(4) { animation-delay: 320ms; }\n.dash-table tbody tr:nth-child(n + 5) { animation-delay: 360ms; }\n\n.status-bar-fill {\n    transform-origin: left center;\n    animation: dash-bar-grow 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;\n}\n\n.dash-progress {\n    position: absolute;\n    top: -6px;\n    left: 0;\n    right: 0;\n    height: 3px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(30, 113, 187, 0.12);\n    z-index: 2;\n}\n\n.dash-progress span {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 35%;\n    border-radius: 999px;\n    background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n    animation: dash-progress 1.1s ease-in-out infinite;\n}\n\n@keyframes dash-rise {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes dash-fade {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes dash-bar-grow {\n    from { transform: scaleX(0); }\n    to { transform: scaleX(1); }\n}\n\n@keyframes dash-progress {\n    0% { left: -35%; }\n    100% { left: 100%; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .dash-body-inner > *,\n    .dash-kpi-row > .dash-kpi,\n    .dash-table tbody tr,\n    .status-bar-fill,\n    .dash-progress span {\n        animation: none;\n    }\n}\n\n/* LIVE STRIP */\n.dash-live {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n    color: #fff;\n    box-shadow: 0 2px 10px rgba(30, 113, 187, 0.25);\n}\n\n.dash-live-main {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.dash-live-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 8px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.16);\n    font-size: 11px;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n}\n\n.dash-live-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #22c55e;\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);\n    animation: dash-pulse 1.8s infinite;\n}\n\n.dash-live-sep {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.7);\n}\n\n.dash-live-time {\n    font-size: 12px;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.85);\n    white-space: nowrap;\n}\n\n@keyframes dash-pulse {\n    70% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }\n    100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }\n}\n\n/* KPI ROW */\n.dash-kpi-row {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.dash-kpi {\n    background: #fff;\n    border-radius: 12px;\n    padding: 14px 16px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n    min-width: 0;\n}\n\n.dash-kpi-top {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.dash-kpi-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(30, 113, 187, 0.12);\n    color: #1e71bb;\n    flex-shrink: 0;\n}\n\n.dash-kpi-icon-up {\n    background: rgba(22, 163, 74, 0.12);\n    color: #16a34a;\n}\n\n.dash-kpi-icon-down {\n    background: rgba(239, 68, 68, 0.12);\n    color: #ef4444;\n}\n\n.dash-kpi-icon svg {\n    font-size: 16px;\n}\n\n.dash-kpi-label {\n    font-size: 12px;\n    color: #6b7280;\n    line-height: 1.3;\n}\n\n.dash-kpi-value {\n    font-size: 22px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.2;\n    word-break: break-word;\n}\n\n.dash-kpi-delta {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    margin-top: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n}\n\n.dash-kpi-delta-up { color: #16a34a; }\n.dash-kpi-delta-down { color: #ef4444; }\n.dash-kpi-delta-watch { color: #d97706; }\n.dash-kpi-delta-neutral { color: #6b7280; }\n\n/* PANELS */\n.dash-panel {\n    background: #fff;\n    border-radius: 12px;\n    padding: 16px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n}\n\n.dash-panel-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.dash-muted {\n    margin: 2px 0 0;\n    font-size: 12px;\n    color: #6b7280;\n}\n\n.dash-text-btn {\n    border: 0;\n    background: transparent;\n    color: #1e71bb;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.dash-text-btn:hover {\n    text-decoration: underline;\n}\n\n.dash-table-wrap {\n    overflow-x: auto;\n}\n\n.inv-board {\n    padding-bottom: 8px;\n}\n\n.inv-board-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n}\n\n.inv-board-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 0;\n}\n\n.dash-export-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    height: 34px;\n    padding: 0 14px;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    background: #eef3fb;\n    color: #2b3991;\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    white-space: nowrap;\n}\n\n.dash-export-btn i {\n    font-size: 14px;\n    line-height: 1;\n}\n\n.dash-export-btn:hover:not(:disabled) {\n    background: #e2ebf8;\n}\n\n.dash-export-btn:disabled {\n    opacity: 0.65;\n    cursor: default;\n}\n\n.inv-mix {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.inv-mix-bar {\n    display: flex;\n    height: 8px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: #eef2f6;\n}\n\n.inv-mix-bar span {\n    display: block;\n    height: 100%;\n    min-width: 4px;\n}\n\n.inv-mix-pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.inv-mix-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 30px;\n    padding: 4px 10px;\n    border: 1px solid #e6ebf2;\n    border-radius: 999px;\n    background: #f8fafc;\n    color: #334155;\n    font-size: 12px;\n    line-height: 1;\n}\n\n.inv-mix-pill i {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.inv-mix-pill strong {\n    font-size: 12px;\n    color: #0f172a;\n}\n\n.inv-mix-pill em {\n    font-style: normal;\n    color: #64748b;\n}\n\n.inv-mix-pill.is-total {\n    background: #eef5fb;\n    border-color: #c9dff3;\n}\n\n.inv-mix-empty {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n.dash-inventory-wrap {\n    max-height: 560px;\n    overflow: auto;\n    border: 1px solid #e8edf3;\n    border-radius: 10px;\n}\n\n.inv-board .dash-inventory-table td {\n    padding: 9px 10px;\n}\n\n.inv-board .inv-sku {\n    font-weight: 600;\n    color: #1e3a5f;\n}\n\n.inv-board tr.is-hold td {\n    background: #fffaf3;\n}\n\n.inv-board td.is-hold-qty {\n    color: #b45309;\n    font-weight: 700;\n}\n\n.dash-table.dash-inventory-table {\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.dash-inventory-table thead th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: #fff;\n    box-shadow: inset 0 -1px 0 #e5e7eb;\n    font-weight: 700;\n    color: #0f172a;\n    letter-spacing: 0.3px;\n}\n\n.dash-inventory-table thead tr.dash-inventory-filter-row th {\n    top: 34px;\n    z-index: 1;\n    padding: 6px 8px 8px;\n    font-weight: 400;\n    text-transform: none;\n    letter-spacing: normal;\n    box-shadow: inset 0 -1px 0 #e5e7eb;\n    background: #f8fafc;\n}\n\n.dash-col-filter {\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    border: 1px solid #d6dee8;\n    border-radius: 6px;\n    padding: 5px 8px;\n    font-size: 12px;\n    color: #111827;\n    background: #fff;\n    outline: none;\n}\n\n.dash-col-filter:focus {\n    border-color: #1e71bb;\n    box-shadow: 0 0 0 2px rgba(30, 113, 187, 0.12);\n}\n\n.dash-col-filter::placeholder {\n    color: #94a3b8;\n}\n\n.dash-inventory-table th.dash-num,\n.dash-inventory-table td.dash-num {\n    text-align: right;\n    white-space: nowrap;\n}\n\n.dash-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.dash-table th {\n    text-align: left;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.4px;\n    text-transform: uppercase;\n    color: #6b7280;\n    padding: 8px 10px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.dash-table td {\n    padding: 12px 10px;\n    font-size: 13px;\n    color: #111827;\n    border-bottom: 1px solid #f3f4f6;\n    vertical-align: middle;\n}\n\n.dash-table tbody tr:hover td {\n    background: #f8fafc;\n}\n\n.dash-status-name {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 600;\n}\n\n.dash-num {\n    font-weight: 600;\n}\n\n.dash-muted-cell {\n    color: #6b7280;\n}\n\n.dash-share {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 160px;\n}\n\n.dash-share .status-bar-bg {\n    flex: 1;\n}\n\n.dash-share span {\n    width: 40px;\n    font-weight: 600;\n    font-size: 13px;\n}\n\n.dash-table-empty,\n.dash-chart-empty {\n    text-align: center;\n    color: #6b7280;\n    font-size: 13px;\n    padding: 28px 12px;\n}\n\n.dash-pill {\n    display: inline-flex;\n    align-items: center;\n    border-radius: 999px;\n    padding: 3px 10px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.dash-pill-open {\n    background: #dbeafe;\n    color: #1d4ed8;\n}\n\n.dash-pill-good {\n    background: #dcfce7;\n    color: #15803d;\n}\n\n.dash-pill-watch {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.dash-pill-critical {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n.dash-split {\n    display: grid;\n    grid-template-columns: minmax(260px, 0.85fr) minmax(340px, 1.35fr);\n    gap: 16px;\n    margin-top: 16px;\n}\n\n.dash-rank-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 14px;\n}\n\n.dash-rank {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 4px;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.dash-rank:last-child {\n    border-bottom: 0;\n}\n\n.dash-rank-index {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.dash-rank-body {\n    flex: 1;\n    min-width: 0;\n}\n\n.dash-rank-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n}\n\n.dash-rank-pct {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.dash-legend {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 10px 14px;\n}\n\n.dash-legend span {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #374151;\n}\n\n.dash-legend i {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.dash-tooltip {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 10px 12px;\n    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n    min-width: 160px;\n}\n\n.dash-tooltip-label {\n    font-size: 12px;\n    font-weight: 700;\n    color: #111827;\n    margin-bottom: 6px;\n}\n\n.dash-tooltip-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #4b5563;\n    margin-top: 4px;\n}\n\n.dash-tooltip-row strong {\n    margin-left: auto;\n    color: #111827;\n}\n\n@media (max-width: 1200px) {\n    .dash-kpi-row {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 860px) {\n    .dash-kpi-row,\n    .dash-split {\n        grid-template-columns: 1fr;\n    }\n\n    .dash-live {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n/* CARD */\n.card {\n    background: #fff;\n    border-radius: 12px;\n    padding: 16px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n}\n\n.card-title {\n    font-size: 15px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.subtitle {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n/* STATUS */\n.status-bars {\n    margin-top: 10px;\n}\n\n.status-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 8px;\n}\n\n.status-label {\n    width: 120px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n}\n\n.dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n}\n\n.status-bar-bg {\n    flex: 1;\n    height: 8px;\n    background: #e5e7eb;\n    border-radius: 4px;\n}\n\n.status-bar-fill {\n    height: 100%;\n    border-radius: 4px;\n}\n\n.status-count {\n    width: 90px;\n    font-weight: 600;\n    text-align: right;\n    font-size: 13px;\n}\n\n.status-percent {\n    font-size: 11px;\n    color: #6b7280;\n}\n\n/* BAR HEADER */\n.card-header-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.chart-select {\n    padding: 4px 8px;\n    font-size: 12px;\n}\n\n\n\n/* ================= HEADER ================= */\n\n.dashboard-header {\n    background: #fff;\n    padding: 10px 12px;\n    border-radius: 14px;\n    margin-bottom: 12px;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(30, 57, 145, 0.06);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.dash-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.dash-toolbar-copy {\n    min-width: 0;\n}\n\n.dashboard-header h2 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.2;\n    letter-spacing: -0.01em;\n    color: #111827;\n}\n\n.dashboard-header p {\n    margin: 2px 0 0;\n    font-size: 11px;\n    line-height: 1.3;\n    color: #6b7280;\n}\n\n.dash-view-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 0;\n    padding: 4px;\n    background: #f4f7fb;\n    border: 1px solid #e6edf5;\n    border-radius: 14px;\n}\n\n.dash-view-tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border: 0;\n    background: transparent;\n    color: #64748b;\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 6px 12px 6px 6px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.dash-view-tab:hover {\n    background: rgba(255, 255, 255, 0.72);\n    color: #1e293b;\n}\n\n.dash-view-tab.is-active {\n    background: #fff;\n    color: #111827;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 6px 16px rgba(30, 57, 145, 0.1);\n}\n\n.dash-view-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;\n}\n\n.dash-view-tab.is-active .dash-view-icon {\n    transform: scale(1.04);\n}\n\n.dash-view-icon-po { background: #e4eef7; color: #1e71bb; }\n.dash-view-icon-asn { background: #e6f6f8; color: #0e7490; }\n.dash-view-icon-so { background: #eeeefe; color: #4f46e5; }\n.dash-view-icon-shipment { background: #f3eefb; color: #6d28d9; }\n.dash-view-icon-grn { background: #e8f6ee; color: #15803d; }\n.dash-view-icon-inventory { background: #e7f4f2; color: #0f766e; }\n\n.dash-view-tab.is-active .dash-view-icon-po { background: #1e71bb; color: #fff; }\n.dash-view-tab.is-active .dash-view-icon-asn { background: #0e7490; color: #fff; }\n.dash-view-tab.is-active .dash-view-icon-so { background: #4f46e5; color: #fff; }\n.dash-view-tab.is-active .dash-view-icon-shipment { background: #6d28d9; color: #fff; }\n.dash-view-tab.is-active .dash-view-icon-grn { background: #15803d; color: #fff; }\n.dash-view-tab.is-active .dash-view-icon-inventory { background: #0f766e; color: #fff; }\n\n/* ---- FILTER CARD ---- */\n.dash-filter-card {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n    flex-shrink: 1;\n    background: #f4f7fb;\n    border: 1px solid #e6edf5;\n    border-radius: 12px;\n    padding: 4px;\n    box-shadow: none;\n}\n\n.dash-filter-inline {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    height: 32px;\n    margin: 0;\n    padding: 0 8px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    color: #64748b;\n}\n\n.dash-filter-inline span {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #64748b;\n}\n\n.dash-date-input {\n    width: 124px;\n    height: 28px;\n    border: 0 !important;\n    border-radius: 0 !important;\n    padding: 0 !important;\n    font-size: 12px !important;\n    background: transparent !important;\n    box-shadow: none !important;\n}\n\n.dash-date-input:focus {\n    border: 0 !important;\n    box-shadow: none !important;\n}\n\n.dash-warehouse-select {\n    border: 0;\n    background: transparent;\n    font-size: 12px;\n    color: #111827;\n    max-width: 168px;\n    outline: none;\n    cursor: pointer;\n}\n\n.dash-filter-btn {\n    padding: 0 12px;\n    font-size: 12px;\n    font-weight: 600;\n    border-radius: 8px;\n    height: 32px;\n    line-height: 1;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    transition: all 0.2s;\n}\n\n.dash-filter-reset {\n    width: 32px;\n    height: 32px;\n    border: 0;\n    border-radius: 8px;\n    background: #fff;\n    color: #64748b;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.dash-filter-reset:hover {\n    background: #eef2f7;\n    color: #111827;\n}\n\n.dash-filter-btn.btn-primary {\n    box-shadow: 0 1px 4px rgba(37, 99, 235, 0.25);\n}\n\n.dash-filter-btn.btn-primary:hover {\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);\n}\n\n.dash-filter-btn.btn-outline-secondary:hover {\n    background: #f3f4f6;\n}\n\n.bar-card {\n    margin-top: 20px;\n}\n\n/* ================= LOADER ================= */\n.dashboard-loader {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 60vh;\n    gap: 14px;\n}\n\n.loader-spinner {\n    width: 36px;\n    height: 36px;\n    border: 4px solid #e5e7eb;\n    border-top-color: #3b82f6;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n.dashboard-loader span {\n    font-size: 14px;\n    color: #6b7280;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
